/**
 * Shop Slice - Handles shop-related state changes
 *
 * Actions handled:
 * - UPDATE_SHOP
 * - SET_SHOP_TIME
 * - SET_SHOP_READY
 * - SET_SHOP_CURRENT_PLAYER
 * - SET_SHOW_SHOP
 * - SET_SHOP_JOKERS_PER_PLAYER
 * - SET_SHOP_REROLL_COUNT
 * - SET_SHOP_JOKER_REROLL_COUNT
 */

// Initial shop state (extracted from initialGameState)
export const initialShopState = {
  shopJokers: [],
  shopBoosters: [],
  shopItems: [],
  shopBundlePerPlayer: [],
  shopReady: [],
  shopRerollCount: 0,
  shopJokerRerollCount: 0,
  shopTimeRemaining: 0,
  shopCurrentPlayer: 0,
  showShop: false,
  shopJokersPerPlayer: [],
};

/**
 * Shop action types
 */
export const SHOP_ACTIONS = [
  'UPDATE_SHOP',
  'SET_SHOP_TIME',
  'SET_SHOP_READY',
  'SET_SHOP_CURRENT_PLAYER',
  'SET_SHOW_SHOP',
  'SET_SHOP_JOKERS_PER_PLAYER',
  'SET_SHOP_REROLL_COUNT',
  'SET_SHOP_JOKER_REROLL_COUNT',
];

/**
 * Check if action is handled by this slice
 */
export function isShopAction(actionType) {
  return SHOP_ACTIONS.includes(actionType);
}

/**
 * Shop reducer slice
 */
export function shopReducer(state, action) {
  switch (action.type) {
    case 'UPDATE_SHOP':
      return {
        ...state,
        shopJokers: action.payload.jokers ?? state.shopJokers,
        shopBoosters: action.payload.boosters ?? state.shopBoosters,
        shopItems: action.payload.items ?? state.shopItems,
        shopRerollCount: action.payload.rerollCount ?? state.shopRerollCount,
        shopJokerRerollCount: action.payload.jokerRerollCount ?? state.shopJokerRerollCount,
      };

    case 'SET_SHOP_TIME':
      return {
        ...state,
        shopTimeRemaining: action.payload,
      };

    case 'SET_SHOP_READY': {
      const newShopReady = [...state.shopReady];
      newShopReady[action.payload.playerIndex] = action.payload.ready;
      return {
        ...state,
        shopReady: newShopReady,
      };
    }

    case 'SET_SHOP_CURRENT_PLAYER':
      return {
        ...state,
        shopCurrentPlayer: action.payload,
      };

    case 'SET_SHOW_SHOP':
      return {
        ...state,
        showShop: action.payload,
      };

    case 'SET_SHOP_JOKERS_PER_PLAYER':
      return {
        ...state,
        shopJokersPerPlayer: action.payload,
      };

    case 'SET_SHOP_REROLL_COUNT':
      return {
        ...state,
        shopRerollCount: action.payload,
      };

    case 'SET_SHOP_JOKER_REROLL_COUNT':
      return {
        ...state,
        shopJokerRerollCount: action.payload,
      };

    default:
      return state;
  }
}

export default shopReducer;
